<template>
	<div class="div-week">
    <div class="week_title-ml">{{$t('read.catalogue')}}</div>
    <!-- 进度条 -->
    <el-progress class="nqtLearnPercent" id="learnPercent" :text-inside="true" :stroke-width="$CONST.MENU.MAX_WIDTH_STROKE_PROGESS" :percentage="Math.abs(nqtLearnPercent) > $CONST.MENU.MAX_PERCENT ? $CONST.MENU.MAX_PERCENT : Math.abs(nqtLearnPercent)" :format="formats(Math.abs(nqtLearnPercent))"></el-progress>
    <div v-if="isLoadData">
      <ul>
        <li class="div-week-nd" v-for="(item1, index1) in data" :key="index1">
          <template v-if="index1 == 0">
            <div class="noteDot">
              <span class="dot dot--undone"></span>
              <span>{{$t('week.undone')}}</span>
              <span class="dot dot--studing"></span>
              <span>{{$t('week.studing')}}</span>
              <span class="dot dot--done"></span>
              <span>{{$t('week.done')}}</span>
            </div>
            <ul class="tb-week font-blod">
              <li>{{$t('week.exercise')}}</li>
              <li>{{$t('week.score')}}</li>
            </ul>
          </template>
          <template>
            <template v-if="item1.thirdOutlineList == null">
              <ul class="nested parent-ul active">
                <li :class="[{noTitle:item1.thirdOutlineList == null}, {exerciseDoneDraft:item1.learningState == $CONST.MENU.LEARNING_COMPLETED && item1.thirdOutlineList == null}]">
                  <template v-if="item1.thirdOutlineList == null">
                    <template v-if="item1.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item1.passingRateQuiz)<=item1.scoreNew">
                      <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                    </template>
                    <template v-else-if="item1.learningState == $CONST.MENU.LEARNING || item1.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item1.passingRateQuiz)>item1.scoreNew">
                      <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                    </template>
                    <template v-else>
                      <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                    </template>
                  </template>
                  <span :class="[{caret:item1.thirdOutlineList != null}, {'caret-down': activeMenu == item1.id || activeMenu == null}]" @click="item1.thirdOutlineList == null ? jumpToLesson(item1, {}, {}, {}, {}, item1) : toggleClass($event, item1.id)">{{item1.chapterName}}</span>
                  <ul v-if="item1.thirdOutlineList == null" class="tb-week" :class="[{infoParent:item1.thirdOutlineList == null}]">
                    <template>
                      <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                        <template v-if="item1.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item1.score) < parseInt(item1.passingRateQuiz))"><li @click="jumpToExercise(item1, {}, {}, {}, {}, item1)"><img src="../../../static/images/baitap-do.png"></li></template>
                        <template v-else-if="item1.exerciseType == $CONST.MENU.EXERCISE_FINISHED"><li @click="jumpToExercise(item1, {}, {}, {}, {}, item1)"><img src="../../../static/images/baitap-xanhla.png"></li></template>
                        <template v-else><li @click="jumpToExercise(item1, {}, {}, {}, {}, item1)"><img src="../../../static/images/baitap-den.png"></li></template>
                      </template>
                      <template v-else><li>—</li></template>
                    </template>
                    <!-- score -->
                    <template>
                      <template v-if="item1.score != '—'"><li class="nqt-score" :class="[{done_score: item1.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, {}, {}, {}, {}, item1)"><a class="btn-number">{{item1.score}}%</a></li></template>
                      <template v-else><li>{{item1.score}}</li></template>
                    </template>
                  </ul>
                </li>
              </ul>
            </template>
            <template v-else>
              <span :class="[{caret:item1.thirdOutlineList != null}, {'caret-down': activeMenu == item1.id || activeMenu == null}]" class="parent-ul-ol caret-float" @click="item1.thirdOutlineList == null ? jumpToLesson(item1, {}, {}, {}, {}, item1) : toggleClass($event, item1.id)">{{item1.chapterName}}</span>
              <ul v-if="item1.thirdOutlineList == null" class="tb-week" :class="[{infoParent:item1.thirdOutlineList == null}]">
                <template>
                  <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                    <template v-if="item1.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item1.score) < parseInt(item1.passingRateQuiz))"><li @click="jumpToExercise(item1, {}, {}, {}, {}, item1)"><img src="../../../static/images/baitap-do.png"></li></template>
                    <template v-else-if="item1.exerciseType == $CONST.MENU.EXERCISE_FINISHED"><li @click="jumpToExercise(item1, {}, {}, {}, {}, item1)"><img src="../../../static/images/baitap-xanhla.png"></li></template>
                    <template v-else><li @click="jumpToExercise(item1, {}, {}, {}, {}, item1)"><img src="../../../static/images/baitap-den.png"></li></template>
                  </template>
                  <template v-else><li>—</li></template>
                </template>
                <!-- score -->
                <template>
                  <template v-if="item1.score != '—'"><li class="nqt-score" :class="[{done_score: item1.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, {}, {}, {}, {}, item1)"><a class="btn-number">{{item1.score}}%</a></li></template>
                  <template v-else><li>{{item1.score}}</li></template>
                </template>
              </ul>
            </template>
          </template>
          <ul v-if="item1.thirdOutlineList != null && item1.thirdOutlineList.length > 0" :class="[{nested:item1.thirdOutlineList != null}, {active:activeMenu == item1.id || activeMenu == null}]">
            <li v-for="(item2, index2) in item1.thirdOutlineList" :class="[{noTitle:item2.thirdOutlineList == null}, {exerciseDoneDraft:item2.learningState == $CONST.MENU.LEARNING_COMPLETED && item2.thirdOutlineList == null}]" :key="index2">
              <template v-if="item2.thirdOutlineList == null">
                <template v-if="item2.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item2.passingRateQuiz)<=item2.scoreNew">
                  <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                </template>
                <template v-else-if="item2.learningState == $CONST.MENU.LEARNING || item2.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item2.passingRateQuiz)>item2.scoreNew">
                  <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                </template>
                <template v-else>
                  <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                </template>
              </template>
              <span :class="[{caret:item2.thirdOutlineList != null}]" class="caret-down color-2" @click="item2.thirdOutlineList == null ? jumpToLesson(item1, item2, {}, {}, {}, item2) : toggleClass($event, item1.id)">{{item2.chapterName}}</span>
              <ul v-if="item2.thirdOutlineList == null" class="tb-week">
                <template>
                  <template v-if="item2.isExercise != $CONST.MENU.EXERCISE_NONE">
                    <template v-if="item2.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item2.score) < parseInt(item2.passingRateQuiz))"><li @click="jumpToExercise(item1, item2, {}, {}, {}, item2)"><img src="../../../static/images/baitap-do.png"></li></template>
                    <template v-else-if="item2.exerciseType == $CONST.MENU.EXERCISE_FINISHED"><li @click="jumpToExercise(item1, item2, {}, {}, {}, item2)"><img src="../../../static/images/baitap-xanhla.png"></li></template>
                    <template v-else><li @click="jumpToExercise(item1, item2, {}, {}, {}, item2)"><img src="../../../static/images/baitap-den.png"></li></template>
                  </template>
                  <template v-else><li>—</li></template>
                </template>
                <!-- score -->
                <template>
                  <template v-if="item2.score != '—'"><li class="nqt-score" :class="[{done_score: item2.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, {}, {}, {}, item2)"><a class="btn-number">{{item2.score}}%</a></li></template>
                  <template v-else><li>{{item2.score}}</li></template>
                </template>
              </ul>
              <ul v-if="item2.thirdOutlineList != null && item2.thirdOutlineList.length > 0" :class="[{nested:item2.thirdOutlineList != null}]" class="active">
                <li v-for="(item3, index3) in item2.thirdOutlineList" :class="[{noTitle:item3.thirdOutlineList == null}, {exerciseDoneDraft:item3.learningState == $CONST.MENU.LEARNING_COMPLETED && item3.thirdOutlineList == null}]" :key="index3">
                  <template v-if="item3.thirdOutlineList == null">
                    <template v-if="item3.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item3.passingRateQuiz)<=item3.scoreNew">
                      <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                    </template>
                    <template v-else-if="item3.learningState == $CONST.MENU.LEARNING || item3.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item3.passingRateQuiz)>item3.scoreNew">
                      <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                    </template>
                    <template v-else>
                      <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                    </template>
                  </template>
                  <span :class="[{caret:item3.thirdOutlineList != null}]" class="caret-down color-3" @click="item3.thirdOutlineList == null ? jumpToLesson(item1, item2, item3, {}, {}, item3) : toggleClass($event, item1.id)">{{item3.chapterName}}</span>
                  <ul v-if="item3.thirdOutlineList == null" class="tb-week">
                    <template>
                      <template v-if="item3.isExercise != $CONST.MENU.EXERCISE_NONE">
                        <template v-if="item3.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item3.score) < parseInt(item3.passingRateQuiz))"><li @click="jumpToExercise(item1, item2, item3, {}, {}, item3)"><img src="../../../static/images/baitap-do.png"></li></template>
                        <template v-else-if="item3.exerciseType == $CONST.MENU.EXERCISE_FINISHED"><li @click="jumpToExercise(item1, item2, item3, {}, {}, item3)"><img src="../../../static/images/baitap-xanhla.png"></li></template>
                        <template v-else><li @click="jumpToExercise(item1, item2, item3, {}, {}, item3)"><img src="../../../static/images/baitap-den.png"></li></template>
                      </template>
                      <template v-else><li>—</li></template>
                    </template>
                    <!-- score -->
                    <template>
                      <template v-if="item3.score != '—'"><li class="nqt-score" :class="[{done_score: item3.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, {}, {}, item3)"><a class="btn-number">{{item3.score}}%</a></li></template>
                      <template v-else><li>{{item3.score}}</li></template>
                    </template>
                  </ul>
                  <ul v-if="item3.thirdOutlineList != null && item3.thirdOutlineList.length > 0" :class="[{nested:item3.thirdOutlineList != null}]" class="active">
                    <li v-for="(item4, index4) in item3.thirdOutlineList" :class="[{noTitle:item4.thirdOutlineList == null}, {exerciseDoneDraft:item4.learningState == $CONST.MENU.LEARNING_COMPLETED && item4.thirdOutlineList == null}]" :key="index4">
                      <template v-if="item4.thirdOutlineList == null">
                        <template v-if="item4.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item4.passingRateQuiz)<=item4.scoreNew">
                          <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                        </template>
                        <template v-else-if="item4.learningState == $CONST.MENU.LEARNING || item4.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item4.passingRateQuiz)>item4.scoreNew">
                          <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                        </template>
                        <template v-else>
                          <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                        </template>
                      </template>
                      <span :class="[{caret:item4.thirdOutlineList != null}]" class="caret-down color-4" @click="item4.thirdOutlineList == null ? jumpToLesson(item1, item2, item3, item4, {}, item4) : toggleClass($event, item1.id)">{{item4.chapterName}}</span>
                      <ul v-if="item4.thirdOutlineList == null" class="tb-week">
                        <template>
                          <template v-if="item4.isExercise != $CONST.MENU.EXERCISE_NONE">
                            <template v-if="item4.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item4.score) < parseInt(item4.passingRateQuiz))"><li @click="jumpToExercise(item1, item2, item3, item4, {}, item4)"><img src="../../../static/images/baitap-do.png"></li></template>
                            <template v-else-if="item4.exerciseType == $CONST.MENU.EXERCISE_FINISHED"><li @click="jumpToExercise(item1, item2, item3, item4, {}, item4)"><img src="../../../static/images/baitap-xanhla.png"></li></template>
                            <template v-else><li @click="jumpToExercise(item1, item2, item3, item4, {}, item4)"><img src="../../../static/images/baitap-den.png"></li></template>
                          </template>
                          <template v-else><li>—</li></template>
                        </template>
                        <!-- score -->
                        <template>
                          <template v-if="item4.score != '—'"><li class="nqt-score" :class="[{done_score: item4.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, item4, {}, item4)"><a class="btn-number">{{item4.score}}%</a></li></template>
                          <template v-else><li>{{item4.score}}</li></template>
                        </template>
                      </ul>
                      <ul v-if="item4.thirdOutlineList != null && item4.thirdOutlineList.length > 0" :class="[{nested:item4.thirdOutlineList != null}]" class="active">
                        <li v-for="(item5, index5) in item4.thirdOutlineList" :class="[{noTitle:item5.thirdOutlineList == null}, {exerciseDoneDraft:item5.learningState == $CONST.MENU.LEARNING_COMPLETED && item5.thirdOutlineList == null}]" :key="index5">
                          <template v-if="item5.thirdOutlineList == null">
                            <template v-if="item5.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item5.passingRateQuiz)<=item5.scoreNew">
                              <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                            </template>
                            <template v-else-if="item5.learningState == $CONST.MENU.LEARNING || item5.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item5.passingRateQuiz)>item5.scoreNew">
                              <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                            </template>
                            <template v-else>
                              <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                            </template>
                          </template>
                          <span :class="[{caret:item5.thirdOutlineList != null}]" class="color-5" @click="item5.thirdOutlineList == null ? jumpToLesson(item1, item2, item3, item4, item5, item5) : toggleClass($event, item1.id)">{{item5.chapterName}}</span>
                          <ul v-if="item5.thirdOutlineList == null" class="tb-week">
                            <template>
                              <template v-if="item5.isExercise != $CONST.MENU.EXERCISE_NONE">
                                <template v-if="item5.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item5.score) < parseInt(item5.passingRateQuiz))"><li @click="jumpToExercise(item1, item2, item3, item4, item5, item5)"><img src="../../../static/images/baitap-do.png"></li></template>
                                <template v-else-if="item5.exerciseType == $CONST.MENU.EXERCISE_FINISHED"><li @click="jumpToExercise(item1, item2, item3, item4, item5, item5)"><img src="../../../static/images/baitap-xanhla.png"></li></template>
                                <template v-else><li @click="jumpToExercise(item1, item2, item3, item4, item5, item5)"><img src="../../../static/images/baitap-den.png"></li></template>
                              </template>
                              <template v-else><li>—</li></template>
                            </template>
                            <!-- score -->
                            <template>
                              <template v-if="item5.score != '—'"><li class="nqt-score" :class="[{done_score: item5.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, item4, item5, item5)"><a class="btn-number">{{item5.score}}%</a></li></template>
                              <template v-else><li>{{item5.score}}</li></template>
                            </template>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <loading class="loading--lesson" :showLoading="!isLoadData" />
	</div>
</template>

<script>
  import Vue from 'vue'
  import {lang} from '../../assets/languages/getLanguageType.js';
  import loading from "@/components/loading/loading";
  Vue.prototype.$lang = lang;
	export default {
		name: 'scheduleWeek',
		props: ["childChapterName","learnPercent"],
		data() {
			return {
				data: [],
        cns: [],
        nqtLearnPercent: this.$CONST.MENU.MIN_PERCENT,
        isLoadData: false,
        userId: null,
				courseName: null,
        activeMenu: null,
        messageExist: false,
        courseNameMenu: "",
			}
		},
    components: {
      loading,
    },
		methods: {
      formats(learnPercent) {
        if (document.getElementsByClassName("el-progress-bar__innerText")[0] != null) {
          document.getElementsByClassName("el-progress-bar__innerText")[0].innerText = learnPercent + '%';
        }
      },
      toggleClass(event, parentID) {
        event.target.classList.toggle("caret-down");
        event.target.nextElementSibling.classList.toggle("active");
        // Đóng cái này, mở cái kia
        // this.activeMenu = parentID;
      },
			getCourseSubOutlineListByTopOutline: async function(param) {
        this.courseNameMenu = param.courseName;
        // console.log(`Page: menu`);
				this.courseName = param.courseName;
				this.userId = param.userId;
				delete param.courseName;
        param.userId = null;
        const self = this;
				this.$api.post("/courseStudy/getScheduleCourseSubOutlineListByTopOutline", param).then(
					async (response) => {
            let listResponseData = response.data;
            Promise.all(listResponseData).then( function(results) {
              let dataCp = listResponseData;
              dataCp.forEach(async (item, i) => {
                item['exerciseType'] = item.questionStatus;
                let keyParent = dataCp.findIndex(x => x.id == item.parentId);
                if (keyParent >= 0) {
                  dataCp[keyParent].thirdOutlineList = dataCp[keyParent].thirdOutlineList == null ? [] : dataCp[keyParent].thirdOutlineList;
                  dataCp[keyParent].thirdOutlineList.push(item);
                }
                if (item.score=="—") {
                  if (item.isExercise==0) {
                    item["scoreNew"] = 100;
                  } else {
                    item["scoreNew"] = 0;
                  }
                } else {
                  item["scoreNew"] = parseInt(item.score);
                }
              });
              dataCp.forEach(value => {
                if (value.id) {
                  self.$api.post("/courseStudy/getScheduleCourseMaterialNew", {
                    "courseOutlineId": value.id,
                    "languageType": self.$lang()
                  }).then((res) => {
                    let checkStatusLearning = false;
                    if (res.data.materialList) {
                      res.data.materialList.forEach(element => {
                        if(value.id==element.courseOutlineId){
                          if (element.learningState!=0) {
                            checkStatusLearning = true;
                          }
                        }
                      });
                    }
                    value['checkStatusLearning'] = checkStatusLearning;
                  });
                }
              });
              self.data = dataCp.filter((x) => {return x.level == 1});
              self.isLoadData = true;
            })
					}
				).catch(() => {
        });
        this.$api.post("/courseStudy/getScheduleCourseProcess", {
          courseId: param.courseId
        })
        .then(response => {
          this.nqtLearnPercent = Number(response.data);
        });
			},
      getExercise: function (data) {
        const self = this;
        return new Promise((resolve, reject) => {
          self.$api.post("/courseStudy/getScheduleLastHomeworkInfo", {
                "courseOutlineId": data,
                "languageType": self.$lang()
          }).then((response) => {
            let exerciseType = response.data.length ? self.$CONST.MENU.EXERCISE_SENT : 2;
            // console.log(`exerciseType: ${exerciseType} -- ID: ${data}`);
            resolve(exerciseType);
          });
        });
      },
      jumpToLesson: function(item1, item2, item3, item4, item5, oop) {
        if (oop.thirdOutlineList != null) return;
        let outlineInfo = {
          "topId": item1.id != undefined ? item1.id : null,
          "secondId": item2.id != undefined ? item2.id : null,
          "secondChapterName": oop.chapterName,
          "thirdId": item3.id != undefined ? item3.id : null,
          "fourthId": item4.id != undefined ? item4.id : null,
          "fifthId": item5.id != undefined ? item5.id : null,
          "type": this.$CONST.MENU.TYPE,
          "courseId": oop.courseId,
          "courseName": this.courseName,
          "level": oop.level,
          "activeID": oop.id,
          "activeMenu": item1.id
        };
        this.$api
        .post("/courseStudy/getScheduleCourseMaterialNew", {
          courseOutlineId: oop.id,
          languageType: this.$lang(),
        })
        .then((response) => {
          if (response.data.materialList == null || response.data.materialList.length == 0) {
            this.$message.warning(window.vm.$i18n.t('js.dataNone'));
            return;
          }
          this.$router.push({
            path: "/home/scheduleLesson",
            query: {
              outlineInfo: JSON.stringify(outlineInfo)
            }
          })
        });
      },
      jumpTaskResult: function (item1, item2, item3, item4, item5, oop) {
        if (oop.thirdOutlineList != null) return;
        let outlineInfo = {
          "topId": item1.id != undefined ? item1.id : null,
          "secondId": item2.id != undefined ? item2.id : null,
          "secondChapterName": oop.chapterName,
          "thirdId": item3.id != undefined ? item3.id : null,
          "fourthId": item4.id != undefined ? item4.id : null,
          "fifthId": item5.id != undefined ? item5.id : null,
          "type": this.$CONST.MENU.TYPE,
          "courseId": oop.courseId,
          "courseName": this.courseNameMenu,
          "courseOutlineId":oop.id
        };
        this.$router.push({
          path: "/home/schedule/schedule_task_result",
          query: {
            outlineInfo: JSON.stringify(outlineInfo)
          }
        });
      },
      jumpToExercise: function(item1, item2, item3, item4, item5, oop) {
        if(oop.checkStatusLearning){
          this.$message.warning(window.vm.$i18n.t('new.title104'));
          return;
        }
        if (oop.isExercise == this.$CONST.MENU.EXERCISE_NONE) {
          this.$message.warning(window.vm.$i18n.t('js.dataNone'));
          return;
        }
        let outlineInfo = {
          "topId": item1.id != undefined ? item1.id : null,
          "secondId": item2.id != undefined ? item2.id : null,
          "secondChapterName": oop.chapterName,
          "thirdId": item3.id != undefined ? item3.id : null,
          "fourthId": item4.id != undefined ? item4.id : null,
          "fifthId": item5.id != undefined ? item5.id : null,
          "type": this.$CONST.MENU.TYPE,
          "courseId": oop.courseId,
          "courseName": this.courseNameMenu,
          "courseOutlineId":oop.id
        };
        this.$router.push({
          path: "/home/schedule/schedule_task_answer",
          query: {
            outlineInfo: JSON.stringify(outlineInfo)
          }
        })
      },
		}
	}
</script>
<style scoped>
  .dot.dot--undone {
    width:15px;
    cursor: default;
  }

  .tb-week li {
    display: flex;
    justify-content: center;
  }

  .dot.dot--done {
    width: 15px;
    cursor: default;
  }

/* ------------ */
  .dot.dot--studing{
    background: #da251d;
  }
  .nqtLearnPercent {
    margin-bottom: 15px;
  }
  .parent-ul-ol {
    margin-bottom: 0;
    text-transform: none;
    color: #000000;
    font-size: 14px;
    font-weight: normal;
  }
  span.caret.caret-down {
    text-transform: none;
    color: #000000;
  }
  .parent-ul {
    font-size: 14px;
  }
  .nqt-mobie {
    display: none;
  }
  @media (max-width: 834px) {
    .nqt-mobie {
      display: block;
    }
  }
  .done_score a{
    background: #118e07;
  }
</style>




// WEBPACK FOOTER //
// src/views/schedule/scheduleWeek.vue